// Copyright 2018-2023 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import RequireAuthentication from "./RequireAuthentication";

export default RequireAuthentication;
